import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGS = ['en', 'es', 'de'];

const LanguageHandler: React.FC = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const match = location.pathname.match(/^\/(en|es|de)(\/|$)/);
    if (match) {
      const lang = match[1];
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    }
  }, [location.pathname, i18n]);

  useEffect(() => {
    const lang = i18n.language?.split('-')[0] || 'en';
    if (SUPPORTED_LANGS.includes(lang)) {
      document.documentElement.lang = lang;
    }
  }, [i18n.language]);

  return null;
};

export default LanguageHandler;
